// import commonTableColumns from "@root/components/table/commonTableColumns";
import Tooltip from '@root/components/v2/ui-elements/Tooltip';
import { VulnerabilityCounts } from '../VulnerabilityCounts';
import Text from '@root/components/v2/ui-elements/Text';
// import DateFormatPipe from "@root/components/utilities/DateFormatPipe";

export const workloadColumns = [
  // commonTableColumns.environment('account_id'),
  {
    field: 'name',
    headerName: 'Workload',
    width: 230,
    renderCell: params => (
      <Tooltip title={params.row.name ?? params.row.workload_id}>
        <Text font="medium" fontStyle="13px" className="m-0 SingleLine">
          {params.row.name ?? params.row.workload_id}
        </Text>
      </Tooltip>
    ),
  },

  // {
  //   field: 'containers',
  //   headerName: 'Containers',
  //   renderCell: (parmas)=> {
  //     return parmas.row.containers.length > 0 && parmas.row.containers[0]
  //   },
  //   width: 230,
  // },
  // {
  //   field: 'pod',
  //   headerName: 'Pods',
  //   width: 250,
  // },

  {
    field: 'namespace',
    headerName: 'Namespace',
    width: 200,
  },
  {
    field: 'cluster',
    headerName: 'Cluster',
    width: 200,
  },

  {
    field: 'vulnerabilities',
    headerName: 'Vulnerabilities',
    width: 300,
    renderCell: params => {
      return params?.row?.vulnerability_counts ? (
        <VulnerabilityCounts vulnerabilities={params.row.vulnerability_counts} />
      ) : (
        '-'
      );
    },
  },
];
